// src/axios.js
import axios from 'axios';
import { Message } from 'element-ui';
import router from './router';

let isRedirectingToLogin = false;

function handleAuthExpired() {
    if (isRedirectingToLogin) {
        return;
    }
    isRedirectingToLogin = true;
    localStorage.removeItem('token');
    Message.warning('登录已过期，请重新登录');

    const currentPath = window.location.pathname + window.location.search;
    const redirect = currentPath && currentPath.indexOf('/login') !== 0 ? currentPath : '';
    router.replace({
        path: '/login',
        query: redirect ? { redirect } : {}
    }).catch(() => {});
}

router.afterEach(to => {
    if (to.path !== '/login') {
        isRedirectingToLogin = false;
    }
});

// 创建 Axios 实例
const instance = axios.create({
    // 设置api地址
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 100000,  // 请求超时设置
});

// 请求拦截器：在请求发送前自动加上 Authorization token
instance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token'); // 从本地存储获取 token
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // 在请求头部带上 token
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器：自动获取返回的 Authorization 并保存
instance.interceptors.response.use(
    response => {
        if (response.data.code === 450 || response.data.code === 403) {
            handleAuthExpired();
            // 登录页会接管页面，挂起当前请求避免触发未处理的 Promise 异常
            return new Promise(() => {});
        }
        // 检查响应数据中的 code 字段
        if (response.data.code !== 0) {
            // 根据实际需要抛出具体错误
            return Promise.reject(new Error(response.data.msg || '请求失败'));
        }

        const token = response.headers['authorization']; // 获取返回头部中的 Authorization
        if (token) {
            localStorage.setItem('token', token); // 将 token 保存到本地存储
        }

        return response.data;
    },
    error => {
        const data = error.response && error.response.data;
        if (data && (data.code === 450 || data.code === 403)) {
            handleAuthExpired();
            return new Promise(() => {});
        }
        return Promise.reject(error);
    }
);

// 原来的地址
const oldInstance = axios.create({
    // 设置api地址
    baseURL: 'http://shkjgw.shkjem.com/api/',
    timeout: 5000,  // 请求超时设置
});

// 将 axios 的静态方法 all 和 spread 添加到自定义实例上
instance.all = axios.all;
instance.spread = axios.spread;

oldInstance.all = axios.all;
oldInstance.spread = axios.spread;

export {instance, oldInstance};
